











































import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import I18nMixin from '@/Shared/I18nMixin';
import Note from './Note';

const NotesEditor = mixins(I18nMixin).extend({
    name: 'NotesEditor',
    props: {
        title: {
            type: String,
            required: true
        },
        notes: {
            type: Array as () => Note[],
            default: [],
            required: false
        },
        addDisabled: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    computed: {
        i18nPrefix() { return 'notes.editor'; }
    },
    methods: {
        addNote() {
            this.$emit('noteAdded', {...this.currentNote});

            this.currentNote = { noteText: ''} as Note;
        }
    },
    data() {
        return {
            currentNote: {
                noteText: ''
            } as Note
        };
    }
});

export default NotesEditor;
